import { render, staticRenderFns } from "./PendingCitationUploader.vue?vue&type=template&id=238de2b5"
import script from "./PendingCitationUploader.vue?vue&type=script&lang=ts"
export * from "./PendingCitationUploader.vue?vue&type=script&lang=ts"
import style0 from "./PendingCitationUploader.vue?vue&type=style&index=0&id=238de2b5&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports